<template>
    <v-container grid-list-xs fluid>
        <v-card>
            <v-toolbar color="primary" dense dark>
                <v-spacer></v-spacer>
                <v-toolbar-title class="white--text">
                    New Transacting
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-form ref="form" lazy-validation class="mb-2">
                    <v-row justify="center">
                        <v-col cols="2">
                            <v-text-field
                                label="Start Date"
                                id="StartDate"
                                :value="StartDate"
                                :placeholder="$store.state.placeholder"
                                v-mask="$store.state.mask"
                                :rules="$store.state.dateRules"
                                dense
                                hide-details
                                required
                            ></v-text-field>
                        </v-col>
                        <v-col cols="2">
                            <v-text-field
                                label="End Date"
                                id="EndDate"
                                :value="EndDate"
                                :placeholder="$store.state.placeholder"
                                v-mask="$store.state.mask"
                                :rules="$store.state.dateRules"
                                dense
                                hide-details
                                required
                            ></v-text-field>
                        </v-col>
                        <!-- <v-col cols="2">
                            <v-combobox v-model="customer" placeholder="Select Customer" class="mx-3" label="Customer"
                                :items="customers" :rules="[v => !!v || 'Required']" required dense hide-details
                                :item-text="'Name'" :item-value="'id'" auto-select-first></v-combobox>
                        </v-col> -->
                        <v-btn
                            color="primary"
                            small
                            class="my-auto ml-2"
                            @click="getReadyToTransact"
                            >Ready to Transact</v-btn
                        >

                        <!-- <v-btn color="primary" small class="my-auto ml-2" @click="getReadyToTransactPayroll"
                        >Ready to Transact Payroll</v-btn> -->
                    </v-row>
                </v-form>
                <ReadyToTransact
                    v-if="readyRevenue"
                    :payroll="payroll"
                    :revenue="revenue"
                    :parms="parms"
                ></ReadyToTransact>

                <!-- <transactpayroll v-if="readyPayroll" :data="readytotransact" :parms="parms"></transactpayroll> -->
            </v-container>
        </v-card>
    </v-container>
</template>
<script>
import axios from 'axios';
import ReadyToTransact from './Contents/ReadyToTransact.vue';
// import transactpayroll from './Contents/TransactPayroll.vue';
import { mask } from 'vue-the-mask';
export default {
    components: {
        ReadyToTransact
        // transactpayroll
    },
    directives: { mask },
    data: function() {
        return {
            customer: null,
            customers: [],
            StartDate: '',
            parms: [],
            EndDate: '',
            orders: [],

            headers: [
                { text: 'Customer', value: 'Customer' },
                { text: 'OrderStatus', value: 'OrderStatus' },
                { text: 'OrderID', value: 'OrderID' },
                { text: 'Product', value: 'Product' },
                { text: 'TempAdjQuantity', value: 'TempAdjQuantity' },
                { text: 'InvRate', value: 'InvRate' },
                { text: 'InvGasRate', value: 'InvGasRate' }
            ],

            showTable: false,
            notPost: false,
            exeption: false,
            readytotransact: [],
            readyRevenue: false,
            readyPayroll: false,
            exeptions: []
        };
    },
    async mounted() {
        // this.loadCustomers();
        this.$store.state.transacting.NoRate = true;
    },
    methods: {
        goToTransacting: function(itm) {
            this.$store.state.newTransact.go = itm.ShiftDetail;
            this.$router.push('/administration/transacting');
        },
        loadCustomers: function() {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('customer/active')
                .then(response => {
                    console.log(response.data.data);
                    this.customers = response.data.data;
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
            str.state.isLoading = false;
        },
        validate() {
            if (this.$refs.form.validate() == false) {
                this.$refs.form.validate();
            } else {
                this.showTable = true;
                this.ready = false;
                this.notPost = false;
                this.exeption = false;
                this.getOrdertoTransact();
            }
        },
        transactOrders: function() {
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate'),
                Customer: this.customer.id
            };
            axios
                .post('new-transaction/transact', parms)
                .then(async response => {
                    this.transactions = response.data;
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },

        getReadyToTransact: function() {
            this.resetVars();
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate')
            };
            axios
                .post('new-transaction/ready-to-transact', parms)
                .then(async response => {
                    this.parms = parms;
                    // this.readytotransact = response.data;
                    this.payroll = response.data['payroll'];
                    this.revenue = response.data['revenue'];
                    this.readyRevenue = true;
                    this.exeption = false;
                    this.showTable = false;
                    this.notPost = false;
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        // getReadyToTransactPayroll: function () {
        //     this.resetVars();
        //     var str = this.$store;
        //     str.state.isLoading = true;
        //     var parms = {
        //         StartDate: this.$store.state.getMsk('StartDate'),
        //         EndDate: this.$store.state.getMsk('EndDate'),
        //     };
        //     axios
        //         .post('new-transaction/ready-to-transact/payroll', parms, {
        //             headers: {
        //                 Authorization: 'Bearer ' + this.$store.state.token
        //             }
        //         })
        //         .then(async response => {
        //             this.parms = parms;
        //             this.readytotransact = response.data;
        //             this.readyPayroll = true;
        //             // this.readyPayroll = true;
        //             str.state.isLoading = false;
        //         })
        //         .catch(function (error) {
        //             console.log(error);
        //             if (error.response.status === 403) {
        //                 str.dispatch('setSnackbar', {
        //                     color: 'error',
        //                     text:
        //                         'You do not have the permission to use this function.'
        //                 });
        //             }
        //             str.state.isLoading = false;
        //         });
        // },
        transactedByShifts: async function() {
            var str = this.$store;
            str.state.isLoading = true;
            const shifts = await this.readytotransact.map(x => {
                return x.ShiftDetail;
            });
            var parms = {
                ShiftDetails: shifts
            };
            axios
                .post('new-transaction/transacted', parms)
                .then(async response => {
                    this.transactions = response.data;
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        getOrdertoTransact: function() {
            this.transactions = [];
            this.orders = [];
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate'),
                Customer: this.customer.id
            };
            axios
                .post('new-transaction/orders/transact', parms)
                .then(async response => {
                    this.orders = response.data;
                    this.showTable = true;
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        downloadExcel: function() {
            var str = this.$store;
            var parms = {
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate'),
                Customer: this.customer.id,
                Export: 1
            };
            str.state.isLoading = true;
            axios
                .post('new-transaction/transact/excel', parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Transactions.xlsx');
                    document.body.appendChild(link);
                    link.click();

                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        transactRev: function(shift) {
            console.log('transactRev');
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .post('new-transaction/transRevenue/' + shift, '')
                .then(response => {
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'Shift Transacted'
                    });
                    console.log(response.data);
                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },

        resetVars: function() {
            this.readyRevenue = false;
            this.readyPayroll = false;
            this.$store.state.newTransact.revenue = true;
            this.$store.state.newTransact.payroll = true;
            this.$store.state.newTransact.all = true;
            this.$store.state.newTransact.NotPost = false;
            this.$store.state.newTransact.exception = false;
        }
    }
};
</script>
